module.exports = __webpack_public_path__ + "img/t-1.59af4e76.jpg";